/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

export const createBusinessPartnerResponseDtoKindEnum = {
  contact: "contact",
  on_behalf: "on_behalf",
} as const

export type CreateBusinessPartnerResponseDtoKindEnumKey =
  (typeof createBusinessPartnerResponseDtoKindEnum)[keyof typeof createBusinessPartnerResponseDtoKindEnum]

export type CreateBusinessPartnerResponseDto = {
  /**
   * @type string
   */
  id: string
  /**
   * @type string
   */
  kind: CreateBusinessPartnerResponseDtoKindEnumKey
}
